__turbopack_context__.v({
  "shortDesc": "MarketplaceV3LoadsSection-module-scss-module__spX_wW__shortDesc",
});
